import { z } from 'zod';
import { addDays, jalaliToApiDate, todayJalali, type JalaliDate, apiDateToJalali } from '@/core/format/jalali';

export type TripType = 'normal' | 'exclusive';
export const MAX_PASSENGERS = 6;

export const defaultSearchDate = (): JalaliDate => addDays(todayJalali(), 1);
export const searchDateToJalali = (s: TripSearch) => apiDateToJalali(s.date) ?? todayJalali();
export const jalaliToSearchDate = jalaliToApiDate;

const schema = z.object({
  origin: z.string().min(1),
  destination: z.string().min(1),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).catch(() => jalaliToApiDate(defaultSearchDate())),
  passengers: z.coerce.number().int().min(1).max(MAX_PASSENGERS).catch(1),
  type: z.enum(['normal', 'exclusive']).catch('normal'),
});

export interface TripSearch {
  origin: string;
  destination: string;
  /** Gregorian YYYY-MM-DD, as the API expects. */
  date: string;
  passengers: number;
  type: TripType;
}

/** The URL is the source of truth for a search → shareable, refresh-safe, back-button friendly. */
export function parseSearch(p: URLSearchParams): TripSearch | null {
  const obj = Object.fromEntries(p);
  if (!obj.date) {
    obj.date = jalaliToApiDate(defaultSearchDate());
  }
  const r = schema.safeParse(obj);
  return r.success ? r.data : null;
}

export const toSearchParams = (s: TripSearch) =>
  new URLSearchParams({ ...s, passengers: String(s.passengers) });
